var $1f0dc3b9307be026$exports = {};
document.body.innerHTML = `
<table>
  <tr>
    <th>Key</th>
    <th>Value</th>
  </tr>
  <tr>
    <td>CF_PAGES_BRANCH</td>
    <td>${"dev"}</td>
  </tr>
  <tr>
    <td>ENV</td>
    <td>${"local"}</td>
  </tr>
  <tr>
    <td>NODE_ENV</td>
    <td>${"preview"}</td>
  </tr>
</table>
`;


//# sourceMappingURL=repo.bc6c96f2.js.map
